import React from 'react';
import { MAIN_THEME } from '@styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  footer: {
    position: 'fixed',
    bottom: '16px',
    left: '24px',
    fontSize: '11px',
    color: MAIN_THEME.color.black,
    zIndex: 1000,
    lineHeight: 1.3,
    fontWeight: 400,
    opacity: 0.8,
    pointerEvents: 'none',
    userSelect: 'none'
  }
}));

const Footer: React.FC = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.footer}>
      © {new Date().getFullYear()} UFA Assurance,
      <br />
      All Rights Reserved.
    </div>
  );
};

export default Footer;
